import styled from "styled-components";

export const AnswerContainer = styled.div<{ isSelected: boolean }>`
    background-color: ${({ isSelected }) => (isSelected ? "var(--color-petrol)" : "#fff")};
    border: ${({ isSelected }) => (isSelected ? "1px solid var(--color-blue-700)" : "1px solid var(--color-orange-100)")};
    border-radius: 8px;
    padding: 16px;
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-bottom: 8px;
    &:hover {
        background-color: var(--color-petrol);
    }
`;

export const AnswerGraphic = styled.div`
    display: flex;
`; 

export const AnswerDot = styled.div<{ isSelected: boolean }>`
    width: 10px;
    height: 10px; 
    background-color: ${({ isSelected }) => (isSelected ? "#fff" : "var(--color-blue-100)")};
    border-radius: 10px;
    margin-right: 16px;
     ${AnswerContainer}:hover & {
        background-color: #fff;
    }
`;

export const AnswerTitle = styled.div<{ isSelected: boolean }>`
    display: flex;
    color: ${({ isSelected }) => (isSelected ? "#fff" : "var(--color-coal)")};

    ${AnswerContainer}:hover & {
        color: #fff;
    }
`;

export const Content = styled.p`
    font-size: 16px;
    margin-bottom: 0px;
`;